export const API_URL = "https://admin.pameldinger.no/api/a";